import { render } from "./RecipeCard.vue?vue&type=template&id=12733341&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"

import "./recipeCard.css?vue&type=style&index=0&id=12733341&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12733341"]])

export default __exports__